<template>
  <orderPage :type="'customer-wait'"></orderPage>
</template>

<script>
import orderPage from "../order-template/index.vue";
export default {
  name: "customerWait",
  components: {
    orderPage
  },
  methods: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
